import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BoxFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.74 7.02L12 2.82L14.9 4.52L7.58 8.74L4.74 7.02ZM9.12 9.56L16.38 5.36L19.28 7.06L11.96 11.28L9.12 9.56ZM11.14 12.6V20.6L4.08 16.54V8.5L11.14 12.6ZM12.86 12.6L19.92 8.52V16.54L12.86 20.6V12.6Z" />
    </SvgIcon>
  );
});
